import React, { Component, useEffect, useState } from 'react'
import moment from 'moment'
import sort_icon from "../../../images/general/arrow_2.svg";
import sort_icon_up from "../../../images/general/arrow_1.svg";
import { updateInvoiceOrder, updateIsPaymentReceivedOrder } from '../../../actions/updateOrderPaymentActions'
import { useDispatch, useSelector, connect } from 'react-redux'
import * as actions from "../../../actions/actions";
import { withRouter } from 'react-router-dom';
import Loader from "../../../components/LoaderNew/Loader"
import _ from 'lodash'

class ReportsPage extends Component {
    constructor(props) {
        super(props);

        const dataArray = props.reportsPageData?.dataArray || [];
        const allResources = this.getUniqueResources(dataArray);

        this.state = {
            // ===== ORIGINAL DATA (source of truth) =====
            original_data_array: JSON.parse(JSON.stringify(dataArray)),

            // ===== FILTERED + SORTED DATA (display this) =====
            filtered_data_array: JSON.parse(JSON.stringify(dataArray)),

            // ===== SORT STATES =====
            sorted_tab: "customer_name",
            sort_type_client: false,
            sort_type_process: false,
            sort_type_calculated_amount: false,
            sort_type_calculated_actual: false,
            sort_type_resource: false,
            sort_type_order_number: false,
            sort_type_order_value: false,
            sort_type_percentage: false,

            // ===== FILTER STATES =====
            selectedResource: "all",
            allResources: allResources,

            // ===== TRACKING =====
            selfTriggeredUpdate: false,
            dataForCsv: [],
            total_actual: props.reportsPageData.calculated_total_actual || props.reportsPageData.total_actual
        }
    }

    // ==========================================
    // USER/RESOURCE FILTER HELPERS
    // ==========================================

    getUniqueResources = (dataArray = []) => {
        const resourceSet = new Set();
        dataArray.forEach(item => {
            // NEW: sub_contractor_name is a single string, not an array
            if (item.sub_contractor_name) {
                resourceSet.add(item.sub_contractor_name);
            }
        });
        return Array.from(resourceSet).sort((a, b) => a.localeCompare(b));
    };

    getFilteredData = (selectedResource) => {
        const { original_data_array } = this.state;

        if (!selectedResource || selectedResource === "all") {
            return JSON.parse(JSON.stringify(original_data_array));
        }

        // NEW: exact match on sub_contractor_name string
        return original_data_array
            .filter(item => item.sub_contractor_name === selectedResource)
            .map(item => ({ ...item }));
    };

    getFilteredTotals = (filteredData = []) => {
        let total_planned = 0;
        let total_actual = 0;

        filteredData.forEach(item => {
            // NEW: use calculated_amount and calculated_actual
            total_planned += Number(item.calculated_amount || 0);
            total_actual += Number(item.calculated_actual || 0);
        });

        return { total_planned, total_actual };
    };

    // ==========================================
    // FILTER HANDLERS
    // ==========================================

    handleResourceChange = (e) => {
        const selectedResource = e.target.value;
        const filtered_data_array = this.getFilteredData(selectedResource);

        this.setState({
            selectedResource,
            filtered_data_array,
            selfTriggeredUpdate: true,
            // Reset all sorts
            sorted_tab: "customer_name",
            sort_type_client: false,
            sort_type_process: false,
            sort_type_calculated_amount: false,
            sort_type_calculated_actual: false,
            sort_type_resource: false,
            sort_type_order_number: false,
            sort_type_order_value: false,
            sort_type_percentage: false,
        }, () => {
            this.props.updateDataArray(filtered_data_array);
        });
    };

    clearFilter = () => {
        const { original_data_array } = this.state;
        const filtered_data_array = JSON.parse(JSON.stringify(original_data_array));

        this.setState({
            selectedResource: "all",
            filtered_data_array,
            selfTriggeredUpdate: true,
            // Reset all sorts
            sorted_tab: "customer_name",
            sort_type_client: false,
            sort_type_process: false,
            sort_type_calculated_amount: false,
            sort_type_calculated_actual: false,
            sort_type_resource: false,
            sort_type_order_number: false,
            sort_type_order_value: false,
            sort_type_percentage: false,
        }, () => {
            this.props.updateDataArray(filtered_data_array);
        });
    };

    // ==========================================
    // SORTING (ALL COLUMNS)
    // ==========================================

    sortDate = (sort_by) => {
        const {
            filtered_data_array,
            sort_type_client,
            sort_type_process,
            sort_type_calculated_amount,
            sort_type_calculated_actual,
            sort_type_resource,
            sort_type_order_number,
            sort_type_order_value,
            sort_type_percentage,
        } = this.state;

        let copy_data = JSON.parse(JSON.stringify(filtered_data_array));
        let sort_data;

        if (sort_by === "sub_contractor_name") {
            sort_data = copy_data.sort((a, b) =>
                (a.sub_contractor_name || '').localeCompare(b.sub_contractor_name || '')
            );
            if (!sort_type_resource) sort_data.reverse();
            this.setState({ sort_type_resource: !sort_type_resource });

        } else if (sort_by === "order_number") {
            sort_data = copy_data.sort((a, b) => {
                const valA = String(a.order_number || '');
                const valB = String(b.order_number || '');
                return valA.localeCompare(valB, undefined, { numeric: true });
            });
            if (!sort_type_order_number) sort_data.reverse();
            this.setState({ sort_type_order_number: !sort_type_order_number });

        } else if (sort_by === "customer_name") {
            sort_data = copy_data.sort((a, b) =>
                (a.customer_name || '').localeCompare(b.customer_name || '')
            );
            if (!sort_type_client) sort_data.reverse();
            this.setState({ sort_type_client: !sort_type_client });

        } else if (sort_by === "process") {
            sort_data = copy_data.sort((a, b) =>
                (a.process || '').localeCompare(b.process || '')
            );
            if (!sort_type_process) sort_data.reverse();
            this.setState({ sort_type_process: !sort_type_process });

        } else if (sort_by === "percentage") {
            sort_data = copy_data.sort((a, b) =>
                (Number(a.percentage) || 0) - (Number(b.percentage) || 0)
            );
            if (!sort_type_percentage) sort_data.reverse();
            this.setState({ sort_type_percentage: !sort_type_percentage });

        } else if (sort_by === "calculated_amount") {
            sort_data = copy_data.sort((a, b) =>
                (Number(a.calculated_amount) || 0) - (Number(b.calculated_amount) || 0)
            );
            if (!sort_type_calculated_amount) sort_data.reverse();
            this.setState({ sort_type_calculated_amount: !sort_type_calculated_amount });

        } else if (sort_by === "order_value") {
            sort_data = copy_data.sort((a, b) =>
                (Number(a.order_value) || 0) - (Number(b.order_value) || 0)
            );
            if (!sort_type_order_value) sort_data.reverse();
            this.setState({ sort_type_order_value: !sort_type_order_value });

        } else if (sort_by === "calculated_actual") {
            sort_data = copy_data.sort((a, b) =>
                (Number(a.calculated_actual) || 0) - (Number(b.calculated_actual) || 0)
            );
            if (!sort_type_calculated_actual) sort_data.reverse();
            this.setState({ sort_type_calculated_actual: !sort_type_calculated_actual });
        }

        this.setState({
            filtered_data_array: sort_data,
            sorted_tab: sort_by,
            selfTriggeredUpdate: true
        }, () => {
            this.props.updateDataArray(sort_data);
        });
    }

    // ==========================================
    // UPDATES
    // ==========================================

    updateDataForCsv = (idx, item, changes) => {
        let filtered = [...this.state.filtered_data_array];
        filtered[idx] = { ...item, ...changes };

        let original = [...this.state.original_data_array];
        let origIdx = original.findIndex(
            o => o.stage_id === item.stage_id &&
                o.order_id === item.order_id &&
                o.sub_contractor_id === item.sub_contractor_id
        );
        if (origIdx > -1) {
            original[origIdx] = { ...original[origIdx], ...changes };
        }

        this.setState({
            filtered_data_array: filtered,
            original_data_array: original,
            selfTriggeredUpdate: true
        }, () => this.props.updateDataArray(filtered));
    }

    componentDidUpdate(prevProps) {
        const { reportsPageData, updateStagesInFinancialReport, updateTotalActualValue } = this.props;

        // 1. Update data from parent
        if (
            reportsPageData?.dataArray &&
            !_.isEqual(prevProps?.reportsPageData?.dataArray, reportsPageData.dataArray)
        ) {
            if (this.state.selfTriggeredUpdate) {
                this.setState({ selfTriggeredUpdate: false });
            } else {
                const newData = reportsPageData.dataArray;
                const allResources = this.getUniqueResources(newData);

                const { selectedResource } = this.state;

                // Check if selected resource exists in new data
                let resourceStillExists = selectedResource === "all";
                if (selectedResource !== "all") {
                    resourceStillExists = newData.some(
                        item => item.sub_contractor_name === selectedResource
                    );
                }

                const activeResource = resourceStillExists ? selectedResource : "all";

                let filtered;
                if (activeResource === "all") {
                    filtered = JSON.parse(JSON.stringify(newData));
                } else {
                    filtered = newData
                        .filter(item => item.sub_contractor_name === activeResource)
                        .map(item => ({ ...item }));
                }

                this.setState({
                    original_data_array: JSON.parse(JSON.stringify(newData)),
                    filtered_data_array: filtered,
                    allResources,
                    selectedResource: activeResource
                });
            }
        }

        // 2. Update total_actual
        const newTotalActual = reportsPageData?.calculated_total_actual ?? reportsPageData?.total_actual;
        const prevTotalActual = prevProps?.reportsPageData?.calculated_total_actual ?? prevProps?.reportsPageData?.total_actual;

        if (newTotalActual !== prevTotalActual) {
            this.setState({ total_actual: newTotalActual });
        }

        // 3. Update total_actual based on invoice
        const prevInvoice = prevProps?.updateStagesInFinancialReport?.updateStageInvoice;
        const currInvoice = updateStagesInFinancialReport?.updateStageInvoice;

        if (currInvoice && prevInvoice !== currInvoice) {
            const delta = currInvoice.invoice_issued ? currInvoice.value : -currInvoice.value;
            this.setState(prevState => ({
                total_actual: prevState.total_actual + delta
            }), () => updateTotalActualValue(this.state.total_actual));
        }
    }

    // ==========================================
    // RENDER
    // ==========================================

    render() {
        const { startingDate, endingDate, reportsPageData, isGenerated, isViewOnlyAccess } = this.props;
        const {
            original_data_array,
            filtered_data_array,
            sorted_tab,
            sort_type_client,
            sort_type_process,
            sort_type_calculated_amount,
            sort_type_calculated_actual,
            sort_type_resource,
            sort_type_order_number,
            sort_type_order_value,
            sort_type_percentage,
            total_actual,
            selectedResource,
            allResources
        } = this.state;

        // Calculate displayed totals
        const isFiltered = selectedResource !== "all";

        const displayedTotals = isFiltered
            ? this.getFilteredTotals(filtered_data_array)
            : this.getFilteredTotals(original_data_array);

        const displayPlanned = isFiltered
            ? displayedTotals.total_planned
            : (reportsPageData.calculated_total_planned ?? displayedTotals.total_planned);

        const displayActual = isFiltered
            ? displayedTotals.total_actual
            : (reportsPageData.calculated_total_actual ?? total_actual);

        return (
            <div className="reports-page__reports">
                <header>
                    <h1>דוח קבלן משנה פיננסי</h1>
                    <h2>
                        <span>{typeof endingDate === "string" ? endingDate : moment(endingDate).format('DD/MM/YYYY')}</span>
                        <span> - </span>
                        <span>{typeof startingDate === "string" ? startingDate : moment(startingDate).format('DD/MM/YYYY')}</span>
                    </h2>
                </header>

                {/* ===== USER / RESOURCE FILTER ===== */}
                <section className="new-reports-page__reports__filter">
                    <div style={filterContainerStyle}>
                        <label htmlFor="resource-filter" style={filterLabelStyle}>
                            סינון לפי משתמש/משאב:
                        </label>
                        <select
                            id="resource-filter"
                            value={selectedResource}
                            onChange={this.handleResourceChange}
                            style={filterSelectStyle}
                        >
                            <option value="all">הכל</option>
                            {allResources.map((resource, idx) => (
                                <option key={resource + idx} value={resource}>
                                    {resource}
                                </option>
                            ))}
                        </select>

                        {isFiltered && (
                            <button onClick={this.clearFilter} style={clearButtonStyle}>
                                נקה סינון ✕
                            </button>
                        )}
                    </div>
                </section>

                <section className="reports-page__reports__general-data">
                    <div className="reports-page__reports__general-data--section1">
                        <span>
                            <p>סה"כ סכום שלב:</p>
                            <p>
                                {displayPlanned
                                    ? displayPlanned.toLocaleString(undefined, {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 2
                                    })
                                    : 0}
                            </p>
                        </span>
                    </div>
                    <div className="reports-page__reports__general-data--section2">
                        <span>
                            <p>יצא:</p>
                            <p>
                                {displayActual
                                    ? displayActual.toLocaleString(undefined, {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 2
                                    })
                                    : 0}
                            </p>
                        </span>
                    </div>
                </section>

                <div className="reports-page__reports__main-data__header">
                    {/* RESOURCE */}
                    <p onClick={() => this.sortDate("sub_contractor_name")}>
                        משתמש/משאב{' '}
                        {sorted_tab === "sub_contractor_name" ?
                            <img className="sort__icon" src={sort_type_resource ? sort_icon_up : sort_icon} alt="sort icon" /> : null}
                    </p>

                    {/* ORDER NUMBER */}
                    <p onClick={() => this.sortDate("order_number")}>
                        מספר הזמנה{' '}
                        {sorted_tab === "order_number" ?
                            <img className="sort__icon" src={sort_type_order_number ? sort_icon_up : sort_icon} alt="sort icon" /> : null}
                    </p>

                    {/* CUSTOMER NAME */}
                    <p onClick={() => this.sortDate("customer_name")}>
                        שם לקוח{' '}
                        {sorted_tab === "customer_name" ?
                            <img className="sort__icon" src={sort_type_client ? sort_icon_up : sort_icon} alt="sort icon" /> : null}
                    </p>

                    {/* PROCESS */}
                    <p onClick={() => this.sortDate("process")}>
                        שלב{' '}
                        {sorted_tab === "process" ?
                            <img className="sort__icon" src={sort_type_process ? sort_icon_up : sort_icon} alt="sort icon" /> : null}
                    </p>

                    {/* PERCENTAGE */}
                    <p onClick={() => this.sortDate("percentage")}>
                        אחוז קבלן{' '}
                        {sorted_tab === "percentage" ?
                            <img className="sort__icon" src={sort_type_percentage ? sort_icon_up : sort_icon} alt="sort icon" /> : null}
                    </p>

                    {/* ORDER VALUE */}
                    <p onClick={() => this.sortDate("order_value")}>
                        סכום הזמנה{' '}
                        {sorted_tab === "order_value" ?
                            <img className="sort__icon" src={sort_type_order_value ? sort_icon_up : sort_icon} alt="sort icon" /> : null}
                    </p>

                    {/* CALCULATED AMOUNT (% of order_value) */}
                    <p onClick={() => this.sortDate("calculated_amount")}>
                        סכום שלב{' '}
                        {sorted_tab === "calculated_amount" ?
                            <img className="sort__icon" src={sort_type_calculated_amount ? sort_icon_up : sort_icon} alt="sort icon" /> : null}
                    </p>

                    {/* CALCULATED ACTUAL */}
                    <p onClick={() => this.sortDate("calculated_actual")}>
                        יצא{' '}
                        {sorted_tab === "calculated_actual" ?
                            <img className="sort__icon" src={sort_type_calculated_actual ? sort_icon_up : sort_icon} alt="sort icon" /> : null}
                    </p>
                </div>

                {isGenerated ? (
                    <section className="reports-page__reports__main-data">
                        {filtered_data_array && filtered_data_array.length > 0 ? (
                            filtered_data_array.map((item, idx) => {
                                return <ReportRow
                                    key={(item.stage_id || '') + (item.order_id || '') + (item.sub_contractor_id || '') + idx}
                                    updateDataForCsv={this.updateDataForCsv}
                                    idx={idx}
                                    item={item}
                                    isViewOnlyAccess={isViewOnlyAccess}
                                />
                            })
                        ) : (
                            <div style={noDataStyle}>
                                {isFiltered ? 'אין נתונים עבור המשאב שנבחר' : 'אין נתונים'}
                            </div>
                        )}
                    </section>
                ) : <Loader />}
            </div>
        )
    }
}

function ReportRow({ item, idx, updateDataForCsv, isViewOnlyAccess }) {
    const percentage = Number(item.percentage) || 3;
    const orderValue = Number(item.order_value) || 0;
    const calculatedAmount = Number(item.calculated_amount) || 0;
    const calculatedActual = Number(item.calculated_actual) || 0;

    return (
        <div
            key={item.stage_id}
            className={
                item.isDelayed
                    ? "reports-page__reports__main-data__item reports-page__reports__main-data__item--delayed"
                    : "reports-page__reports__main-data__item"
            }
        >
            {/* Sub-contractor name */}
            <p>{item.sub_contractor_name || "-"}</p>

            {/* Order number */}
            <p>{item.order_number || ''}</p>

            {/* Customer name */}
            <p>{item.customer_name || ''}</p>

            {/* Process */}
            <p>{item.process || ''}</p>

            {/* Percentage */}
            <p>{`${percentage}%`}</p>

            {/* Order value */}
            <p>
                {orderValue
                    ? orderValue.toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2
                    })
                    : 0}
            </p>

            {/* Calculated amount: (order_value × percentage) / 100 */}
            <p>
                {calculatedAmount
                    ? calculatedAmount.toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2
                    })
                    : 0}
            </p>

            {/* Calculated actual */}
            <p>
                {calculatedActual
                    ? calculatedActual.toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2
                    })
                    : 0}
            </p>
        </div>
    )
}

// ==========================================
// INLINE STYLES FOR FILTER
// ==========================================

const filterContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '10px 20px',
    direction: 'rtl',
    flexWrap: 'wrap',
    marginBottom: '10px'
};

const filterLabelStyle = {
    fontSize: '16px',
    fontWeight: '600',
    fontFamily: 'Rubik',
    whiteSpace: 'nowrap'
};

const filterSelectStyle = {
    padding: '8px 12px',
    fontSize: '15px',
    fontFamily: 'Rubik',
    borderRadius: '6px',
    border: '1px solid #ccc',
    minWidth: '200px',
    direction: 'rtl',
    cursor: 'pointer',
    outline: 'none',
    background: '#fff'
};

const clearButtonStyle = {
    padding: '6px 14px',
    fontSize: '14px',
    fontFamily: 'Rubik',
    borderRadius: '6px',
    border: '1px solid #e74c3c',
    background: '#fff',
    color: '#e74c3c',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'all 0.2s ease'
};

const noDataStyle = {
    textAlign: 'center',
    padding: '40px 20px',
    fontSize: '18px',
    fontFamily: 'Rubik',
    color: '#999'
};

function mapStateToProps({ updateStagesInFinancialReport }) {
    return { updateStagesInFinancialReport };
}
export default withRouter(connect(mapStateToProps, actions)(ReportsPage))